import { getDataFromSSR } from "@/handlers/client/commonClient";
import dynamic from "next/dynamic";
const BattingStatsTable = dynamic(() =>
  import("@/component/IPL/BattingStatsTable")
);
const BowlingStatsTable = dynamic(() =>
  import("@/component/IPL/BowlingStatsTable")
);
const FieldingStatsTable = dynamic(() =>
  import("@/component/IPL/FieldingStatsTable")
);
const IPLYearsCarousel = dynamic(() =>
  import("@/component/IPL/IPLYearsCarousel")
);
const PlayerStatsCard = dynamic(() =>
  import("@/component/IPL/PlayerStatsCard")
);
const TopPerformerCard = dynamic(() => import("@/component/IPL/TopPerformer"));
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import IPLSponsor from "@/component/IPL/IPLSponser";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));

const IPLMenu = dynamic(() => import("@/component/IPL/IPLMenu"));
const IPLCommonFooter = dynamic(() =>
  import("@/component/IPL/IPLCommonFooter")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
// const WebsiteSchema = dynamic(() =>
//   import("@/component/SeoTags/WebsiteSchema")
// );
// const IPLFAQSchema = dynamic(() => import("@/component/SeoTags/IPLFAQSchema"));
const StatsPage = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  faqData = null,
  statsData = null,
  mostRunData = null,
  mostWicketsData = null,
}) => {
  const battingFilter = [
    "Most Runs",
    "Best Individual Score",
    "Best Batting Average",
    "Best Strike Rate",
    "Most 100s",
    "Most 50s",
    "Most 6s",
    "Most 4s",
  ];
  const bowlingFilter = [
    "Most Wickets",
    "Most 5-Wicket Haul",
    "Best Economy Rates",
    "Best Bowling Strike Rate",
    "Best Bowling Average",
  ];
  const fieldingFilters = ["Most Dismissals", "Most Catches", "Most Run Outs"];
  const iplYearsFilter = {
    2025: "8307",
    2024: "5970",
    2023: "5157",
    2022: "4623",
    2021: "4165",
    2020: "3978",
    2019: "3130",
    2018: "2940",
  };
  const [statData, setStatsData] = useState(statsData?.stats);
  const [readMore, setReadMore] = useState(true);
  const [selectedYear, setSelectedYear] = useState(2025);
  const [tourId, setTourId] = useState("8307"); //2025 tour id
  const [selectedBattingFilter, setBattingFilter] = useState(battingFilter[0]);
  const handleSelectYear = (year) => {
    setSelectedYear(year);
  };

  const handleDropdownChange = (e) => {
    setBattingFilter(e.target.value);
  };

  const [selectedBowlingFilter, setBowlingFilter] = useState(bowlingFilter[0]);
  const handleBowlingDropdownChange = (e) => {
    setBowlingFilter(e.target.value);
  };

  const [selectFieldingFilter, setFieldingFilter] = useState(
    fieldingFilters[0]
  );
  const handleFieldingDropdownChange = (e) => {
    setFieldingFilter(e.target.value);
  };
  useEffect(() => {
    const getStatsData = async () => {
      const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
      // setYearDataLoading(true);
      let data = await getDataFromSSR(
        `${websiteUrl}/api/getStatsAPI?tourID=${tourId}&statsId=0`
      );
      // console.log("statsData", data?.data?.data?.stats);
      setStatsData(data?.data?.data?.stats);
    };
    getStatsData();
  }, [tourId]);
  const [topPerformenceData, setTopPermomenceData] = useState(statsData);
  const [topBatPerformersData, setTopBatPerformersData] = useState(
    statData?.find((value) => value.stat_id == 2)?.leaderboard ?? []
  );
  const [topBowlerPerformersData, setTopBowlerPerformersData] = useState(
    statData?.find((value) => value.stat_id == 13)?.leaderboard ?? []
  );
  const [topFieldingPerformerData, setTopFieldingPerformerData] = useState(
    statData?.find((value) => value.stat_id == 23)?.leaderboard ?? []
  );
  useEffect(() => {
    if (selectedBattingFilter == "Most Runs") {
      setTopBatPerformersData([
        ...topPerformenceData?.stats?.find((value) => value.stat_id == 10)
          ?.leaderboard,
      ]);
    } else if (selectedBattingFilter == "Best Individual Score") {
      setTopBatPerformersData([
        ...topPerformenceData?.stats?.find((value) => value.stat_id == 1)
          ?.leaderboard,
      ]);
    } else if (selectedBattingFilter == "Best Batting Average") {
      setTopBatPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 3)
          ?.leaderboard ?? []),
      ]);
    } else if (selectedBattingFilter == "Best Strike Rate") {
      setTopBatPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 4)
          ?.leaderboard ?? []),
      ]);
    } else if (selectedBattingFilter == "Most 50s") {
      setTopBatPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 5)
          ?.leaderboard ?? []),
      ]);
    } else if (selectedBattingFilter == "Most 100s") {
      setTopBatPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 6)
          ?.leaderboard ?? []),
      ]);
    } else if (selectedBattingFilter == "Most 4s") {
      setTopBatPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 7)
          ?.leaderboard ?? []),
      ]);
    } else if (selectedBattingFilter == "Most 6s") {
      setTopBatPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 8)
          ?.leaderboard ?? []),
      ]);
    }
  }, [selectedBattingFilter]);

  useEffect(() => {
    if (selectedBowlingFilter == "Most Wickets") {
      setTopBowlerPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 13)
          ?.leaderboard ?? []),
      ]);
    } else if (selectedBowlingFilter == "Most 5-Wicket Haul") {
      setTopBowlerPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 17)
          ?.leaderboard ?? []),
      ]);
    } else if (selectedBowlingFilter == "Best Economy Rates") {
      setTopBowlerPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 16)
          ?.leaderboard ?? []),
      ]);
    } else if (selectedBowlingFilter == "Best Bowling Strike Rate") {
      setTopBowlerPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 14)
          ?.leaderboard ?? []),
      ]);
    } else if (selectedBowlingFilter == "Best Bowling Average") {
      setTopBowlerPerformersData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 15)
          ?.leaderboard ?? []),
      ]);
    }
  }, [selectedBowlingFilter]);

  useEffect(() => {
    if (selectFieldingFilter == "Most Catches") {
      setTopFieldingPerformerData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 21)
          ?.leaderboard ?? []),
      ]);
    } else if (selectFieldingFilter == "Most Run Outs") {
      setTopFieldingPerformerData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 22)
          ?.leaderboard ?? []),
      ]);
    } else if (selectFieldingFilter == "Most Dismissals") {
      setTopFieldingPerformerData([
        ...(topPerformenceData?.stats?.find((value) => value.stat_id == 23)
          ?.leaderboard ?? []),
      ]);
    }
  }, [selectFieldingFilter]);

  // ads implement
  const router = useRouter();
  const currentPath = router?.asPath?.split("?")[0];
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const [scrolled, setScrolled] = useState(true);
  // useEffect(() => {
  //   async function onFirstScroll() {
  //     if (!scrolled) {
  //       setScrolled(true);
  //     }
  //   }

  //   function handleScroll() {
  //     onFirstScroll();

  //     window.removeEventListener("scroll", handleScroll);
  //   }

  //   window.addEventListener("scroll", handleScroll);
  // }, []);
  // ads

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                [300, 250],
                "div-gpt-ad-1659434785315-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());
          }

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
          scrolled &&
            googletag?.cmd.push(function () {
              var INTERSTITIALAd = googletag
                ?.defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                  googletag?.enums.OutOfPageFormat.INTERSTITIAL
                )
                ?.addService(googletag.pubads());
              INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }
          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_2_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-3"
              )
              ?.addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);
  }, [scrolled]);
  const masterConfig = useContext(MasterConfigContext);
  const iplKeys = masterConfig["ipl_2025"];

  const title =
    "IPL 2025 Stats: Most Runs, Wickets, Records & Player Rankings – NewsTak";
  const description =
    "Check complete IPL 2025 stats – top scorers, most wickets, best strike rates, team performances & records. Updated after every match.";
  const keywords =
    "IPL 2025 Stats, IPL 2025 Player Stats, IPL 2025 Records, IPL 2025 Team Stats, IPL 2025 Top Scorers, IPL 2025 Most Wickets, IPL 2025 Strike Rate, IPL 2025 Performance Stats, IPL 2025 Player Rankings, Updated IPL Stats 2025";
  const canonical = "/sports/ipl/stats";

  const breadCrumbs = [
    {
      id: "1",
      title: "Sports",
      canonical_url: "/sports",
      amp_url: "",
    },
    {
      id: "2",
      title: "IPL",
      canonical_url: "/sports/ipl",
      amp_url: "",
    },
    {
      id: "3",
      title: "Stats",
      canonical_url: "/sports/ipl/stats",
      amp_url: "",
    },
  ];

  return (
    <div>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      {/* <WebsiteSchema /> */}
      {/* <IPLFAQSchema /> */}
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList
        data={
          categoryNewsListData?.length > 0
            ? [...categoryNewsListData?.content]
            : []
        }
      />
      <Breadcrumb breadcrumbList={breadCrumbs} />
      <MGIDAAdsScript delay={true} />
      <div className="mx-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
      </div>

      {iplKeys?.showSponsor && (
        <IPLSponsor color="white" masterConfigKey={iplKeys} />
      )}
      <IPLMenu />
      <section className="py-2 mx-4">
        <h1 className="text-lg font-semibold my-4">IPL 2025 Stats</h1>
        <p className={`text-[#323232] text-sm text-left relative inline`}>
          <span className={`${readMore ? "line-clamp-2" : "mb-2"}`}>
            इस वर्ष अभी तक LSG के निकोलस पूरन 5 मैचों में 288 रनों के साथ सबसे
            अधिक रन मारने वाले खिलाड़ी बने हुए हैं. 2024 में यह खिताब 741 रनों
            के साथ विराट कोहली के पास था. 2025 में CSK के नूर अहमद ने अभी तक
            सबसे ज्यादा विकेट ली है. वहीं IPL 2024 में हर्षल पटेल 24 विकेटों के
            साथ टूर्नामेंट के सबसे ज्यादा विकेट टेकिंग गेंदबाज बने थे. जब IPL की
            बात आती है तो इसमें होने वाली जबरदस्त फील्डिंग की बात हर कोई करता
            है. इस समय MI के नमन धीर ने 5 मैच खेलकर 7 कैच पकड़े हैं जो सबसे
            ज्यादा है. वहीं 2024 में अक्षर पटेल 14 मैचों में 13 कैच पकड़कर सबसे
            ज्यादा कैच पकड़ने वाले खिलाडी बने थे.
          </span>
          <span
            onClick={() => {
              setReadMore(prev => !prev);
            }}
            className="cursor-pointer inline -ml-[0.5px]  text-primary text-sm"
          >
            {readMore ? "और देखें >" : "< कम देखें"}
          </span>
        </p>
        <TopPerformerCard
          title={""}
          mostRunData={statData?.find((value) => value.stat_id == 10)}
          mostWicketsData={statData?.find((value) => value.stat_id == 13)}
        />
        <IPLYearsCarousel
          matchData={iplYearsFilter}
          handleSelectYear={handleSelectYear}
          selectedYear={selectedYear}
          setTourId={setTourId}
        />
        <h2 className="   my-3 font-semibold text-lg">
          IPL {selectedYear} In Numbers
        </h2>
        <PlayerStatsCard
          tourId={tourId}
          firstTeamName={
            statData?.find((value) => value.stat_id == 2)?.leaderboard[0]
              ?.team_short_name
          }
          secondTeamName={
            statData?.find((value) => value.stat_id == 13)?.leaderboard[0]
              ?.team_short_name
          }
        />
        {scrolled && (
          <div className="my-3">
            <AdSlot300x250
              divId={"div-gpt-ad-1659434604998-0"}
              minWidth="300px"
              minHeight="250px"
            />

            <AdSlot728x90
              divId={"div-gpt-ad-1707804176041-2"}
              minWidth="720px"
              minHeight="90px"
            />
          </div>
        )}
        <h2 className="my-4 mx-3 font-semibold text-lg">Batting Stats</h2>
        {/* use dropdown */}
        <div className="mx-auto">
          <select
            id="battingFilter"
            value={selectedBattingFilter}
            onChange={handleDropdownChange}
            className="border rounded p-2 w-full"
          >
            {/* Example options; replace with relevant options */}
            {battingFilter?.map((item) => (
              <option key={item} value={item}>
                {item}{" "}
              </option>
            ))}
          </select>
        </div>
        <BattingStatsTable
          topBatPerformers={topBatPerformersData ?? []}
          selectedFilter={selectedBattingFilter}
          yearDataLoading={statData ? false : true}
          selectedYear={selectedYear}
        />

        {/* bowling stats */}
        <h2 className="my-4 mx-3 font-semibold text-lg">Bowling Stats</h2>
        <div className="mx-auto">
          <select
            id="bowlingFilter"
            value={selectedBowlingFilter}
            onChange={handleBowlingDropdownChange}
            className="border rounded p-2 w-full"
          >
            {/* Example options; replace with relevant options */}
            {bowlingFilter?.map((item) => (
              <option key={item} value={item}>
                {item}{" "}
              </option>
            ))}
          </select>
        </div>
        <BowlingStatsTable
          tableContent={topBowlerPerformersData ?? []}
          selectedFilter={selectedBowlingFilter}
          selectedYear={selectedYear}
        />
        {scrolled && (
          <div className="my-3">
            <AdSlot300x250
              divId={"div-gpt-ad-1659434785315-0"}
              minWidth="300px"
              minHeight="250px"
            />

            <AdSlot728x90
              divId={"div-gpt-ad-1707804176041-3"}
              minWidth="720px"
              minHeight="90px"
            />
          </div>
        )}
        {/* fielding stats table */}
        <h2 className="my-4 mx-3 font-semibold text-lg">Fielding Stats</h2>
        <div className="mx-auto">
          <select
            id="fieldingFilter"
            value={selectFieldingFilter}
            onChange={handleFieldingDropdownChange}
            className="border rounded p-2 w-full"
          >
            {/* Example options; replace with relevant options */}
            {fieldingFilters?.map((item) => (
              <option key={item} value={item}>
                {item}{" "}
              </option>
            ))}
          </select>
        </div>
        <FieldingStatsTable
          tableContent={topFieldingPerformerData ?? []}
          selectedFilter={selectFieldingFilter}
          selectedYear={selectedYear}
        />
      </section>
      <div className="mx-4">
        <IPLCommonFooter
          categoryNewsListData={categoryNewsListData}
          faqData={faqData}
          isMobileDevice={isMobileDevice}
          showAds={false}
          scrolled={scrolled}
        />
      </div>
      <div className="mx-4">
        {scrolled && (
          <AdSlot300x250
            divId={"div-gpt-ad-1659435474737-0"}
            minWidth="300px"
            minHeight="250px"
          />
        )}

        {scrolled && (
          <AdSlot728x90
            divId="div-gpt-ad-1659425743360-0"
            minWidth="720px"
            minHeight="90px"
          />
        )}
      </div>
      <div data-type="_mgwidget" data-widget-id="1584885"></div>
      <script
        async
        dangerouslySetInnerHTML={{
          __html: `window.addEventListener("load", function() {
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        });`,
        }}
      ></script>
    </div>
  );
};

export default StatsPage;
